import { useState } from 'react';
import './Blog.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/Popup';
import Image from './2.jpg';

const BlogPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <div className='blogPageMainScreen'>
        <div className='blogPageMainScreenContent'>
          <span className='blogPageMainScreenBack' onClick={() => navigate('/blog')}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
              <path
                d='M7.9987 12.6667L3.33203 7.99999M3.33203 7.99999L7.9987 3.33333M3.33203 7.99999H12.6654'
                stroke='#3A6376'
                stroke-width='1.33'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Back to Articles
          </span>
          <h1 className='blogPageMainScreenTitle'>Storytelling: A Powerful Leadership Tool</h1>
          <span className='blogPageMainScreenDate'>December 1, 2025</span>
          <div className='blogPageMainScreenImage'>
            <img src={Image} />
          </div>
        </div>
      </div>
      <div className='blogPageContent'>
        <p>
          As executives, we spend the majority of our day communicating but rarely do we take a moment to consider if we’re
          engaged in authentic dialogue or just quickly sharing essential information. In business, there is a tendency to
          downplay storytelling as part of corporate messaging as frivolous or a waste of time; however, stories often drive the
          most compelling discussions and are a powerful leadership tool.
        </p>
        <p>
          Paul Smith, author of “Lead with a Story: A Guide to Crafting Business Narratives that Captivate, Convince, and Inspire”
          (AMACOM Books, August 2012), says that, “Stories have the ability to engage an audience the way logic and bullet points
          alone never could. Whether you are trying to communicate a vision, sell an idea, or inspire commitment, storytelling is
          a powerful business tool that can mean the difference between mediocre results and phenomenal success.”
        </p>
        <p>
          Storytelling is a way for leaders to inspire the organization, share a vision, teach valuable lessons, define culture
          and values, and explaining who you are and what you believe through an engagement medium that audiences prefer. However,
          what if you don’t think you’re a captivating storyteller? We have five tips that will help you build your storytelling
          skills:
        </p>
        <h4>KNOW YOUR AUDIENCE</h4>
        <p>
          It’s essential to tailor your message to your audience. Who is your audience? How can you relate to them? Why is this
          story for them? If you don’t know what’s relevant to your audience, ask them. As the guide, it’s your responsibility to
          know where you’re taking your audience on the journey and what they expect in return for listening.
        </p>
        <h4>MAKE IT AUTHENTIC</h4>
        <p>
          No one wants to hear some tall tale that’s only told to convey a point. Authenticity helps your team build trust. When
          you’re able to communicate something real, and showing some vulnerability, your audience is more likely to relate to you
          and trust what you say. Focusing on real situations and genuine emotions help to make your storytelling more authentic.
        </p>
        <h4>HIGHLIGHT A STRUGGLE</h4>
        <p>
          A story without a challenge isn’t exciting. Give your story movement, illustrating the problem, and how you will
          overcome the obstacles. Smart leaders develop the conflict and solution in a story that causes their audience to want to
          be part of the journey, even if the road ahead will be challenging.
        </p>
        <h4>KEEP IT SIMPLE</h4>
        <p>
          Not every story has to be epic. Some of the most successful stories are relatively simple and straightforward. Avoid
          frivolous details that detract from your core message. The focus should be on the people you know, lessons you’ve
          learned, or the events you’ve witnessed with just enough detail that can captivate your audience and drive home your
          message.
        </p>
        <h4>PERFECT YOUR APPROACH</h4>
        <p>
          Storytelling is a skill that requires practice and effort to develop. The more you work on how you deliver your message,
          the easier it will be to craft appealing stories.
        </p>
        <p>
          Storytelling helps translate dry and abstract information into persuasive pictures of a leader’s goals. Stories serve as
          emotional connections for sometimes communicating complex data and provide leaders a way to connect with those around
          them. When your next opportunity arises to share information with your team, get creative with your approach, and give
          storytelling a shot.
        </p>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <Footer />
    </div>
  );
};

export default BlogPage;
